import styled, { css } from "styled-components";
import { designTokens, getTypography } from "../../../styles/designTokens";

export const Section = styled.div`
  display: flex;
  flex-direction: column;
  width: 400px;
  height: 100%;
  padding: 32px 40px;
  gap: 40px;
`;

export const Header = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const Title = styled.h2`
  ${getTypography("korean", "body1")}
  color: ${designTokens.colors.font.primary};
  display: flex;
  align-items: center;
  gap: 4px;
`;

export const ActionButton = styled.button`
  padding: 8px 16px;
  border: 1px solid ${designTokens.colors.line.button};
  background: transparent;
  border-radius: 4px;
  ${getTypography("korean", "body3")}
  cursor: pointer;
  display: flex;
  align-items: center;
  color: ${designTokens.colors.font.tertiary};
  gap: 8px;
  &:hover {
    background: ${designTokens.colors.background.primary};
  }
`;

export const List = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

interface CardProps {
  selected?: boolean;
}
export const Card = styled.div<CardProps>`
  display: flex;
  gap: 16px;
  padding: 12px;
  background: ${designTokens.colors.background.primary};
  border-radius: 8px;
  cursor: pointer;
  ${({ selected }) =>
    selected
      ? css`
          border: 2px solid ${designTokens.colors.line.box};
        `
      : css`
          border: 1px solid ${designTokens.colors.line.point};
        `}
  &:hover {
    box-shadow: ${designTokens.shadows.md};
  }
`;

interface ThumbWrapperProps {
  selected?: boolean;
}
export const ThumbnailWrapper = styled.div<ThumbWrapperProps>`
  position: relative;
  flex-shrink: 0;
  width: 160px;
  height: 90px;
  border-radius: 4px;
  overflow: hidden;
  ${({ selected }) =>
    selected
      ? css`
          box-shadow: 0 0 0 2px ${designTokens.colors.line.box};
        `
      : ``}
`;

export const Thumbnail = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
`;

export const Checkmark = styled.div`
  position: absolute;
  top: 8px;
  right: 8px;
  background: ${designTokens.colors.line.box};
  color: #fff;
  width: 20px;
  height: 20px;
  border-radius: 50%;
  font-size: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const Overlay = styled.div`
  position: absolute;
  bottom: 0;
  width: 100%;
  padding: 4px;
  background: rgba(0, 0, 0, 0.6);
  color: #fff;
  font-size: 12px;
  text-align: right;
`;

export const Meta = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
`;

export const FileTitle = styled.div`
  ${getTypography("english", "title2")}
  color: ${designTokens.colors.font.primary};
  margin-bottom: 4px;
`;

export const FileInfo = styled.div`
  ${getTypography("korean", "body2")}
  color: ${designTokens.colors.font.tertiary};
  display: flex;
  gap: 4px;
  margin-bottom: 4px;
`;

export const FileType = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;
  ${getTypography("korean", "body2")}
  color: ${designTokens.colors.font.quaternary};

  svg {
    width: 16px;
    height: 16px;
  }
`;
